import { pList, rKiraGenelBilgi, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';
import { rKiraGenelBilgi_RawData } from '../../../../api/models/rKiraGenelBilgi';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_KIRAGENELBILGI,
    new Api.Bilgi.KiraGenelBilgi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rKiraGenelBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rKiraGenelBilgi> =>
  ActionFunctions.action_async_complete_api<rKiraGenelBilgi>(
    ActionSubTypes.API_KIRAGENELBILGI,
    { Data: new Collection(((data?.Value?.Data as unknown) as any) || []) },
    error
  );
